template = require('./fee_calculator.html.slim')
controller = require('./fee_calculator_controller')

angular.module('wbComponents').directive 'feeCalculator', ->
  replace: true
  restrict: "E"
  scope: {
    investment: '=ngModel',
    cta: '@'
  }
  require: 'ngModel'
  controller: controller
  templateUrl: template
  link: ($scope, $el, $attrs, ctrl) ->
    $attrs.$observe 'showSavings', (value) ->
      $scope.showSavings = value

